import PropTypes from "prop-types";
import styles from "./Updated.module.css";
import classNames from "classnames";
import Moment from "react-moment";
import "moment-timezone";
import { useContext } from "react";
import { TimezoneContext } from "../global/timezone";
import updateTime from "../data/Time.json";

function Updated({ className, update }) {
  const { timezone, changeTimezone } = useContext(TimezoneContext);
  return (
    <h4
      className={classNames([
        styles.updated,
        className === "web" ? styles.web : styles.mobile,
      ])}
      title="click to change timezone"
      onClick={changeTimezone}
    >
      {"Updated "}
      <Moment format="M/D HH:mm z" tz={timezone}>
        {updateTime[update]}
      </Moment>
    </h4>
  );
}

Updated.propTypes = {
  className: PropTypes.string.isRequired,
  service: PropTypes.string,
};

export default Updated;
